import { message } from 'antd';

/**
 * 统一错误处理类
 * 提供一致的错误处理和用户提示
 */
export class ErrorHandler {
  /**
   * 处理API错误
   */
  static handleApiError(error: any, context: string): void {
    console.error(`❌ ${context} 错误:`, error);
    
    // 根据HTTP状态码处理不同类型的错误
    if (error.response?.status === 401) {
      // 未授权，跳转登录
      localStorage.removeItem('token');
      message.error('登录已过期，请重新登录');
      window.location.href = '/login';
    } else if (error.response?.status === 403) {
      // 权限不足
      message.error('权限不足，无法访问此功能');
    } else if (error.response?.status === 404) {
      // 资源不存在
      message.error('请求的资源不存在');
    } else if (error.response?.status === 422) {
      // 请求参数错误
      const detail = error.response?.data?.detail;
      if (Array.isArray(detail)) {
        const errorMessages = detail.map((item: any) => item.msg || item.message).join(', ');
        message.error(`请求参数错误: ${errorMessages}`);
      } else {
        message.error('请求参数错误，请检查输入');
      }
    } else if (error.response?.status >= 500) {
      // 服务器错误
      message.error('服务器内部错误，请稍后重试');
    } else if (error.code === 'ECONNABORTED') {
      // 请求超时
      message.error('请求超时，请检查网络连接');
    } else if (error.message) {
      // 其他错误
      message.error(error.message);
    } else {
      // 默认错误
      message.error('操作失败，请重试');
    }
  }
  
  /**
   * 处理数据错误
   */
  static handleDataError(data: any, context: string): void {
    console.warn(`⚠️ ${context} 数据异常:`, data);
  }
  
  /**
   * 处理验证错误
   */
  static handleValidationError(errors: any[]): void {
    const errorMessages = errors.map(error => error.message).join(', ');
    message.error(`验证失败: ${errorMessages}`);
  }
  
  /**
   * 处理网络错误
   */
  static handleNetworkError(error: any): void {
    console.error('🌐 网络错误:', error);
    message.error('网络连接失败，请检查网络设置');
  }
  
  /**
   * 处理权限错误
   */
  static handlePermissionError(): void {
    message.error('您没有权限执行此操作');
  }
  
  /**
   * 处理业务逻辑错误
   */
  static handleBusinessError(errorMessage: string): void {
    message.error(errorMessage);
  }
  
  /**
   * 静默处理错误（不显示用户提示）
   */
  static handleSilentError(error: any, context: string): void {
    console.error(`🔇 ${context} 静默错误:`, error);
    // 不显示用户提示，只记录日志
  }
}
